import { ExamplePageTemplate } from "./components";
import { travelConfig } from "./configs/exampleConfigs";

const TravelExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={travelConfig.backgroundColor}
      chatButtonColor={travelConfig.chatButtonColor}
      chatButtonIcon={travelConfig.chatButtonIcon}
      header={travelConfig.header}
      hero={travelConfig.hero}
    >
      {travelConfig.content}
    </ExamplePageTemplate>
  );
};

export default TravelExample;